/** @file Writes one impostor's fields into an ImpostorList stride (IMPOSTOR_LAYOUT). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { ImpostorList } from '@zilo/pose3d-render-core/contract';
import { IMPOSTOR_LAYOUT as L } from '@zilo/pose3d-render-core/layout/impostorLayout';

/** Every slot of one impostor by meaning (plan "Field semantics"); `cutOff` is the two-point pivot2 inset (CR-004). */
export type ImpostorFields = {
  a: Vec3; b: Vec3; pivot: [number, number]; tex: [number, number, number, number]; rotate: number;
  scaleX: number; scaleY: number; sheer: number; zBias: number; flags: number; cutAngle: number; cutPos: number;
  cutMode: 0 | 1 | 2; sheet: number; drawable: number; cutOff: number;
};

/** Stride `i` of `out` set from `f`. */
export function writeImpostor(out: ImpostorList, i: number, f: ImpostorFields): void {
  const o = i * L.stride;
  out[o + L.ax] = f.a[0]; out[o + L.ay] = f.a[1]; out[o + L.az] = f.a[2];
  out[o + L.bx] = f.b[0]; out[o + L.by] = f.b[1]; out[o + L.bz] = f.b[2];
  out[o + L.pivotX] = f.pivot[0]; out[o + L.pivotY] = f.pivot[1];
  out[o + L.texX] = f.tex[0]; out[o + L.texY] = f.tex[1]; out[o + L.texW] = f.tex[2]; out[o + L.texH] = f.tex[3];
  out[o + L.rotate] = f.rotate; out[o + L.scaleX] = f.scaleX; out[o + L.scaleY] = f.scaleY; out[o + L.sheer] = f.sheer;
  out[o + L.zBias] = f.zBias; out[o + L.flags] = f.flags;
  out[o + L.cutAngle] = f.cutAngle; out[o + L.cutPos] = f.cutPos; out[o + L.cutMode] = f.cutMode;
  out[o + L.sheet] = f.sheet; out[o + L.drawable] = f.drawable; out[o + L.cutOff] = f.cutOff;
}
